import { Action, Dispatch } from 'redux'
import { initBasketsAction } from 'reducks/basket/actions'

const initBaskets = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(initBasketsAction())
  }
}

export default initBaskets
